Application.Upload = {
    ui: {
        container: '.js-upload',
        dropzone: '.js-upload__dropzone',
        input: '.js-upload__input',
        submit: '.js-upload__submit',
        preview: '.js-upload__preview',
        hint: '.js-upload__hint',
        errors: '.js-upload__errors',
        error: '.js-upload__error',
    },
    ready: function () {

        var self = this;

        if (!$(this.ui.container).length){
            return;
        }

        // drag and drop files
        $(this.ui.dropzone).on('drag dragstart dragend dragover dragenter dragleave drop', function(e) {
            e.preventDefault();
            e.stopPropagation();
        }).on('dragover dragenter', function() {
            $(this).addClass('dragover');
        }).on('dragleave dragend drop', function() {
            $(this).removeClass('dragover');
        }).on('drop', function(e) {
            $(self.ui.input)[0].files = e.originalEvent.dataTransfer.files;
            $(self.ui.input).change();
        });

        // file change
        $(this.ui.input).change(function(){

            var $input = $(this);
            var file = _.first(this.files);

            // remove errors
            self.idle();

            self.validate(file, function(message){

                if (message !== true) {
                    // invalid file type
                    self.error(message);
                    self.preview(null);
                    self.disabledSubmit();
                    self.reset();
                    return;
                }

                self.preview(file);
                self.enableSubmit();

            }, {
                minWidth: $input.attr('data-min-width'),
                minHeight: $input.attr('data-min-height'),
            });

        });

    },
    idle: function(){

        $(this.ui.errors).removeClass('active');
        $(this.ui.error).text('');
        $(this.ui.dropzone).removeClass('error');

    },
    error: function(message){

        var self = this;

        setTimeout(function () {
            $(self.ui.errors).addClass('active');
            $(self.ui.error).text(message);
            $(self.ui.dropzone).addClass('error');
        }, 0)

    },
    validate: function(file, callback, options){

        options = options || {};
        options.minWidth = options.minWidth || 250;
        options.minHeight = options.minHeight || 250;

        if (!_.contains(['image/jpeg', 'image/png'], file.type)){
            callback('Please, upload a JPEG or PNG image file.');
            return;
        }

        if (file.size > 10000000 /* 10 MB */){
            callback('Maximum allowed file size is 10 MB.');
            return;
        }

        // validate image size
        var img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onload = function() {

            var width = img.naturalWidth,
                height = img.naturalHeight;
            window.URL.revokeObjectURL( img.src );

            if (width < options.minWidth || height < options.minHeight){
                callback('The provided image is too small (min. ' + options.minWidth + 'x' + options.minHeight + 'px).');
            }else{
                // all validated
                callback(true);
            }
        };

    },
    enableSubmit: function(){

        $(this.ui.submit).removeClass('btn_disabled');

    },
    disabledSubmit: function(){

        $(this.ui.submit).addClass('btn_disabled');

    },
    preview: function(file){

        // remove current preview
        var $preview = $(this.ui.preview);
        $preview.empty();

        if (!file){
            $(this.ui.dropzone).removeClass('selected');
            return;
        }else{
            $(this.ui.dropzone).addClass('selected');
        }

        // create preview <img>
        var $img = $('<img>');

        var reader = new FileReader();
        reader.onload = (function ($i) {
            return function (e) {
                $i.attr('src', e.target.result);
            };
        })($img);
        reader.readAsDataURL(file);

        // append
        $preview.append($img);

    },
    reset: function () {

        var $container = $(this.ui.dropzone);
        var $input = $(this.ui.input);
        var $form = $('<form>');

        // take out and reset
        $form.append($input);
        $form.get(0).reset();

        // return back to the container
        $container.append($input);

    }
};